import Vue from 'vue'

export default {
    // UPDATE_SESSION (state, value) {
    //     Vue.set(state, 'session', value);
    // },
    // AUTH_SUCCESS (state, value) {
    //     this.commit('UPDATE_SESSION', value);
    // },
    // AUTH_LOGOUT (state, value) {
    //     this.commit('UPDATE_SESSION', value);
    // }
}



// WEBPACK FOOTER //
// ./src/store/modules/test/mutations.js